import { Outlet } from 'react-router-dom'
import { SoundProvider } from '@/stores/useSoundStore'

export default function Layout() {
  return (
    <SoundProvider>
      <main className="min-h-screen w-full bg-retro-gray flex items-center justify-center p-4 font-sans text-gray-900 overflow-hidden">
        <Outlet />
      </main>
    </SoundProvider>
  )
}
